var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupIcloudLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "17px",
    viewBox: "0 0 25 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE4FA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4085F4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-Clip2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-Copy2",
    transform: "translate(-46.000000, -585.000000)",
    fill: "url(#linearGradient-12)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(0.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(16.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gmail-Copy2",
    transform: "translate(0.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Days-Left2",
    transform: "translate(30.170141, 15.820106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-g-icloud2",
    transform: "translate(0.000000, 1.041237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2575642,0 C17.8670558,0 20.7546974,2.79731967 20.9350994,6.40681122 C23.0106498,6.94825915 24.4544303,8.84308496 24.6348323,10.9186353 C24.6348323,13.5356337 22.4690406,15.7012641 19.8522842,15.7012641 L19.8522842,15.7012641 L4.87287005,15.7012641 C2.16571106,15.7012641 0,13.5354724 0,10.828394 C0,8.8431656 1.26329785,7.03841982 3.15828495,6.3165699 C3.24852627,4.51182412 4.69230676,3.06812427 6.49705254,3.06812427 C7.12874179,3.06812427 7.76035039,3.24860692 8.30179832,3.60965284 C9.38469417,1.44386114 11.7309685,0 14.2575642,0 Z",
    id: "Shape2"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupIcloudLogo2);
export default __webpack_public_path__ + "static/media/SignupIcloudLogo2.287098ae858188deffc7d3ab855cc856.svg";
export { ForwardRef as ReactComponent };